import React from "react";

import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import InputLabel from "@mui/material/InputLabel";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";

const orderStatuses = [
  { value: "progressing", text: "Progressing" },
  { value: "production", text: "Production" },
  { value: "freight", text: "Freight" },
  { value: "delay", text: "Delay" },
  { value: "completed", text: "Completed" },
];

const ProductionDetails = ({
  classes,
  isReadOnly,
  productionStartDate,
  setProductionStartDate,
  productionDays,
  setProductionDays,
  estimatedCompletionDate,
  setEstimatedCompletionDate,
  actualCompletionDate,
  setActualCompletionDate,
  freightShippingMethod,
  setFreightShippingMethod,
  confirmedDepartedDate,
  setConfirmedDepartedDate,
  deliveryAddress,
  setDeliveryAddress,
  expectedDeliveryDate,
  setExpectedDeliveryDate,
  trackingDetails,
  setTrackingDetails,
  arrivalDate,
  setArrivalDate,
  confirmedDeliveryDate,
  setConfirmedDeliveryDate,
  orderStatus,
  setOrderStatus,
  delayReason,
  setDelayReason,
}) => {
  return (
    <Paper className={classes.paper} sx={{ height: "100%" }}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <InputLabel className="inputFormCustomLabel">Production Start Date</InputLabel>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <MobileDatePicker
              value={productionStartDate}
              onChange={(date) => setProductionStartDate(date)}
              renderInput={(params) => <TextField {...params} fullWidth variant="outlined" size="small" />}
              inputFormat="DD/MM/YYYY"
              readOnly={isReadOnly}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={12} sm={6}>
          <InputLabel className="inputFormCustomLabel">Production Days</InputLabel>
          <TextField
            fullWidth
            variant="outlined"
            size="small"
            value={productionDays}
            onChange={(e) => setProductionDays(e.target.value)}
            InputProps={{ readOnly: isReadOnly }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <InputLabel className="inputFormCustomLabel">Estimated Completion Date</InputLabel>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <MobileDatePicker
              value={estimatedCompletionDate}
              onChange={(date) => setEstimatedCompletionDate(date)}
              renderInput={(params) => <TextField {...params} fullWidth variant="outlined" size="small" />}
              inputFormat="DD/MM/YYYY"
              readOnly={isReadOnly}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={12} sm={6}>
          <InputLabel className="inputFormCustomLabel">Actual Completion Date</InputLabel>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <MobileDatePicker
              value={actualCompletionDate}
              onChange={(date) => setActualCompletionDate(date)}
              renderInput={(params) => <TextField {...params} fullWidth variant="outlined" size="small" />}
              inputFormat="DD/MM/YYYY"
              readOnly={isReadOnly}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={12} sm={6}>
          <InputLabel className="inputFormCustomLabel">Freight Shipping Method</InputLabel>
          {isReadOnly ? (
            <TextField fullWidth variant="outlined" size="small" value={freightShippingMethod} InputProps={{ readOnly: true }} />
          ) : (
            <TextField
              select
              fullWidth
              variant="outlined"
              size="small"
              value={freightShippingMethod}
              onChange={(e) => setFreightShippingMethod(e.target.value)}
            >
              <MenuItem value={"Sea"}>Sea</MenuItem>
              <MenuItem value={"Air"}>Air</MenuItem>
              <MenuItem value={"Express"}>Express</MenuItem>
            </TextField>
          )}
        </Grid>
        <Grid item xs={12} sm={6}>
          <InputLabel className="inputFormCustomLabel">Confirmed Departed</InputLabel>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <MobileDatePicker
              value={confirmedDepartedDate}
              onChange={(date) => setConfirmedDepartedDate(date)}
              renderInput={(params) => <TextField {...params} fullWidth variant="outlined" size="small" />}
              inputFormat="DD/MM/YYYY"
              readOnly={isReadOnly}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={12}>
          <InputLabel className="inputFormCustomLabel">Delivery Address</InputLabel>
          <TextField
            fullWidth
            multiline
            rows={2}
            variant="outlined"
            size="small"
            value={deliveryAddress}
            onChange={(e) => setDeliveryAddress(e.target.value)}
            InputProps={{ readOnly: isReadOnly }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <InputLabel className="inputFormCustomLabel">Expected Delivery Date</InputLabel>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <MobileDatePicker
              value={expectedDeliveryDate}
              onChange={(date) => setExpectedDeliveryDate(date)}
              renderInput={(params) => <TextField {...params} fullWidth variant="outlined" size="small" />}
              inputFormat="DD/MM/YYYY"
              readOnly={isReadOnly}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={12} sm={6}>
          <InputLabel className="inputFormCustomLabel">Tracking Number or Vessel Details</InputLabel>
          <TextField
            fullWidth
            variant="outlined"
            size="small"
            value={trackingDetails}
            onChange={(e) => setTrackingDetails(e.target.value)}
            InputProps={{ readOnly: isReadOnly }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <InputLabel className="inputFormCustomLabel">Arrival Date</InputLabel>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <MobileDatePicker
              value={arrivalDate}
              onChange={(date) => setArrivalDate(date)}
              renderInput={(params) => <TextField {...params} fullWidth variant="outlined" size="small" />}
              inputFormat="DD/MM/YYYY"
              readOnly={isReadOnly}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={12} sm={6}>
          <InputLabel className="inputFormCustomLabel">Confirmed Delivery Date</InputLabel>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <MobileDatePicker
              value={confirmedDeliveryDate}
              onChange={(date) => setConfirmedDeliveryDate(date)}
              renderInput={(params) => <TextField {...params} fullWidth variant="outlined" size="small" />}
              inputFormat="DD/MM/YYYY"
              readOnly={isReadOnly}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={12} sm={6}>
          <InputLabel className="inputFormCustomLabel">Order Status</InputLabel>
          {isReadOnly ? (
            (() => {
              const status = orderStatuses.find((s) => s.value === orderStatus);
              return (
                <TextField fullWidth variant="outlined" size="small" value={status ? status.text : ""} InputProps={{ readOnly: true }} />
              );
            })()
          ) : (
            <TextField
              select
              fullWidth
              variant="outlined"
              size="small"
              value={orderStatus}
              onChange={(e) => setOrderStatus(e.target.value)}
            >
              {orderStatuses.map((s) => (
                <MenuItem key={s.value} value={s.value}>{s.text}</MenuItem>
              ))}
            </TextField>
          )}
        </Grid>
        <Grid item xs={12}>
          <InputLabel className="inputFormCustomLabel">Delivery Updates</InputLabel>
          <TextField
            fullWidth
            multiline
            rows={2}
            variant="outlined"
            size="small"
            value={delayReason}
            onChange={(e) => setDelayReason(e.target.value)}
            InputProps={{ readOnly: isReadOnly }}
          />
        </Grid>
      </Grid>
    </Paper>
  );
};

export default React.memo(ProductionDetails);
